import { connect } from 'react-redux';

import VenueManagementComponent from '../../components/pages/venueManagement/Venue';

export default connect()(VenueManagementComponent);
